import React, { useEffect, useState } from "react";
import {
  Inject,
  AccumulationChartComponent,
  PieSeries,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  AccumulationLegend,
  AccumulationTooltip,
  AccumulationDataLabel,
} from "@syncfusion/ej2-react-charts";
import axiosClient from "../Utils/axiosClient";
import { useTranslation } from "react-i18next";
const PieChart = () => {
  const [data, setData] = useState([]);

  const { t } = useTranslation();
  useEffect(() => {
    const getChart = async () => {
      try {
        const response = await axiosClient.get("/dashboard/MessageStatistics");

        if (response.status === 200) {
          const statusMapping = {
            delivered: t("MessageStatuses.delivered.label"),
            sent: t("MessageStatuses.sent.label"),
            read: t("MessageStatuses.read.label"),
            error: t("MessageStatuses.error.label"),
          };
          const colorMapping = {
            delivered: "#003f5c",
            sent: "#58508d",
            read: "#bc5090",
            error: "#ff6361",
          };

          const formattedData = response.data.map((item) => ({
            ...item,
            status: statusMapping[item.status] || item.status,
            color: colorMapping[item.status] || "#ffa600",
          }));

          setData(formattedData);
        }
      } catch (error) {}
    };
    getChart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AccumulationChartComponent
      id="pie-chart"
      tilt={-45}
      legendSettings={{ visible: true, position: "Bottom" }}
      width="300px"
      style={{ placeItems: "center" }}
    >
      <Inject
        services={[
          AccumulationLegend,
          PieSeries,
          AccumulationTooltip,
          AccumulationDataLabel,
        ]}
      />
      <AccumulationSeriesCollectionDirective>
        <AccumulationSeriesDirective
          dataSource={data}
          xName="status"
          yName="count"
          type="Pie"
          pointColorMapping="color"
          legendSettings={{ visible: false }}
          enableSmartLabels={true}
          enableAnimation={false}
          center={{ x: "60%", y: "60%" }}
          tooltip={{ enable: false }}
          dataLabel={{
            visible: true,
            position: "Inside",
            name: "text",
            font: {
              fontWeight: "600",
            },
          }}
        ></AccumulationSeriesDirective>
      </AccumulationSeriesCollectionDirective>
    </AccumulationChartComponent>
  );
};

export default PieChart;
